import React from "react";
// import it from "../assets/it.png";
import servers from "../assets/Data.webp";
import software from "../assets/software.webp";
import cloudServices from "../assets/cloud.webp";
import disaster from "../assets/disaster.webp";
import OurClients from "../components/Home/OurClients";
import Digital from "../components/Service/Digital";

const Services = () => {
  return (
    <>
      <div
        className="relative overflow-hidden container mx-auto"
        // style={{
        //   backgroundImage: `url(${it})`,
        //   backgroundSize: "cover",
        //   backgroundPosition: "center",
        //   backgroundRepeat: "no-repeat",
        // }}
      >
        {/* Dark overlay to ensure text readability */}
        <div className="absolute inset-0 bg-gradient-to-br" />
        {/* Content */}
        <div className="relative flex flex-col items-center justify-center mt-32 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-8">
            Our Services
          </h1>
          <p className="max-w-3xl mx-auto text-lg text-gray-300 leading-relaxed">
            At Multify, we offer a comprehensive suite of services designed to
            meet the diverse needs of modern businesses. Here's how we empower
            organizations with cutting-edge technology:
          </p>
        </div>
      </div>
      <div className="py-16 container mx-auto">
        <div className=" ">
          {/* First Service */}
          <div className="grid md:grid-cols-2 gap-8 mb-16 items-center">
            <div className="space-y-4">
              <h2 className="text-2xl md:text-3xl font-bold text-white">
                Data Storage & Hosting Solutions
              </h2>
              <p className="text-gray-300 leading-relaxed mb-10">
                Secure, reliable, and high-performance servers for all your data
                storage and hosting needs. Our solutions ensure data integrity,
                fast accessibility, and robust backups, tailored for industries
                like BFSI, government, and agritech.
              </p>
              <div className="flex gap-[15px] mt-[20px]">
                <button class="px-6 py-3 rounded-full border-2 border-[#ffffff] bg-white text-black font-semibold hover:bg-gray-200 transition">
                  Get Started
                </button>
                <button class="px-6 py-3 rounded-full border-2 border-[#050122] text-white font-semibold bg-gradient-to-r from-[#2A0F85] to-[#4C22E5] hover:opacity-80 transition">
                  Learn More
                </button>
              </div>
            </div>
            <div className="order-first md:order-last">
              <img
                src={servers}
                alt="Software Development"
                className="rounded-lg w-full h-auto object-cover"
              />
            </div>
          </div>

          {/* Second Service */}
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div className="order-first">
              <img
                src={cloudServices}
                alt="Cloud Services"
                className="rounded-lg w-full h-auto object-cover"
              />
            </div>
            <div className="space-y-4">
              <h2 className="text-2xl md:text-3xl font-bold text-white">
                Cloud Services
              </h2>
              <p className="text-gray-300 leading-relaxed">
                Optimize your IT infrastructure with our flexible cloud
                solutions, including public, private, hybrid, and
                industry-specific community clouds. Our AI-powered platforms
                offer advanced vertical autoscaling, real-time resource
                optimization, and cost-efficient pay-per-use billing.
              </p>
              <div className="flex gap-[15px] mt-[20px]">
                <button class="px-6 py-3 rounded-full border-2 border-[#ffffff] bg-white text-black font-semibold hover:bg-gray-200 transition">
                  Get Started
                </button>
                <button class="px-6 py-3 rounded-full border-2 border-[#050122] text-white font-semibold bg-gradient-to-r from-[#2A0F85] to-[#4C22E5] hover:opacity-80 transition">
                  Learn More
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="py-16 container mx-auto">
        <div className="">
          {/* First Service */}
          <div className="grid md:grid-cols-2 gap-8 mb-16 items-center">
            <div className="space-y-4">
              <h2 className="text-2xl md:text-3xl font-bold text-white">
                Software Development & IT Consulting
              </h2>
              <p className="text-gray-300 leading-relaxed">
                Turn your ideas into reality with our custom software
                development services. From concept to deployment, our solutions
                are aligned with your business goals. Our expert IT consulting
                helps you adopt the right technologies to drive growth and
                innovation.
              </p>
              <div className="flex gap-[15px] mt-[20px]">
                <button class="px-6 py-3 rounded-full border-2 border-[#ffffff] bg-white text-black font-semibold hover:bg-gray-200 transition">
                  Get Started
                </button>
                <button class="px-6 py-3 rounded-full border-2 border-[#050122] text-white font-semibold bg-gradient-to-r from-[#2A0F85] to-[#4C22E5] hover:opacity-80 transition">
                  Learn More
                </button>
              </div>
            </div>
            <div className="order-first md:order-last">
              <img
                src={software}
                alt="Software Development"
                className="rounded-lg w-full h-auto object-cover"
              />
            </div>
          </div>

          {/* Second Service */}
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div className="order-first">
              <img
                src={disaster}
                alt="Disaster Recovery & Backup Solutions"
                className="rounded-lg w-full h-auto object-cover"
              />
            </div>
            <div className="space-y-4">
              <h2 className="text-2xl md:text-3xl font-bold text-white">
                Disaster Recovery & Backup Solutions
              </h2>
              <p className="text-gray-300 leading-relaxed">
                Empower your smart devices with seamless IoT connectivity and
                real-time data exchange. Our solutions enable businesses to
                leverage IoT for operational efficiency and enhanced
                decision-making.
              </p>
              <div className="flex gap-[15px] mt-[20px]">
                <button class="px-6 py-3 rounded-full border-2 border-[#ffffff] bg-white text-black font-semibold hover:bg-gray-200 transition">
                  Get Started
                </button>
                <button class="px-6 py-3 rounded-full border-2 border-[#050122] text-white font-semibold bg-gradient-to-r from-[#2A0F85] to-[#4C22E5] hover:opacity-80 transition">
                  Learn More
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Digital />
      <OurClients />
    </>
  );
};

export default Services;
